var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('alert'),_c('table-header'),_c('form-table'),_c('Page',{staticStyle:{"text-align":"center","margin-top":"50px"},attrs:{"total":100,"show-total":"","show-elevator":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }